import React, { useRef } from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import Image from "../../Elements/Image/Image.tsx";
import Button from "../../Elements/Button/Button.js";
import LevelTable from "./LevelTable.js";
import WithdrawTable from "./WithdrawTable.js";
import "./JumboPay.scss";

const mapArray1 = [
  {
    className: "one",
    image: "1_Photographer",
    textKey: "aboutjumbopay-use-cases-photographer",
  },
  {
    className: "two",
    image: "1_Designer",
    textKey: "aboutjumbopay-use-cases-designer",
  },
  {
    className: "one",
    image: "1_musican",
    textKey: "aboutjumbopay-use-cases-musician",
  },
  {
    className: "two",
    image: "1_editor",
    textKey: "aboutjumbopay-use-cases-video-editor",
  },
];
const mapArray2 = [
  {
    className: "three",
    image: "1_Publisher",
    textKey: "aboutjumbopay-use-cases-publisher",
  },
  {
    className: "three",
    image: "1_Copy",
    textKey: "aboutjumbopay-use-cases-copywriter",
  },
  {
    className: "three",
    image: "1_Layer",
    textKey: "aboutjumbopay-use-cases-lawyer",
  },
];
const mapArray3 = [
  {
    className: "three",
    image: "1_Writer",
    textKey: "aboutjumbopay-use-cases-writer",
  },
  {
    className: "three",
    image: "1_Translator",
    textKey: "aboutjumbopay-use-cases-translator",
  },
  {
    className: "three",
    image: "1_Animator",
    textKey: "aboutjumbopay-use-cases-animator",
  },
  {
    className: "three",
    image: "1_Programer",
    textKey: "aboutjumbopay-use-cases-programmer",
  },
];
const JumboPay = () => {
  const { getTextByKey, getHtmlByKey, getPath, getDirection } = useContent();

  const myRef = useRef(null);

  const executeScroll = () => myRef.current.scrollIntoView();
  // run this function from an event handler or an effect to execute scroll

  return (
    <div className="jumboPay-container">
      <div className="section-1">
        <div className="inside-image">
          <div className="intro">
            <h1> {getTextByKey("aboutjumbopay-title")}</h1>
            <p>{getHtmlByKey("aboutjumbopay-intro")}</p>
          </div>

          <Button buttonClass="section-1-button">
            <LinkToNewTab page="home">
              {getTextByKey("aboutjumbopay-request-payment").toUpperCase()}
            </LinkToNewTab>
          </Button>
        </div>

        <div className="outside-image">
          <div className="jumbopay-info-boxes">
            <div className="info-box">
              <div className="image">
                <Image alt="Icon1" name="jumbo-pay/Icon1" ext="png" />
              </div>
              <h3 className="title">
                {getTextByKey("aboutjumbopay-box1-title")}
              </h3>
              <p className="content">
                {getTextByKey("aboutjumbopay-box1-text")}
              </p>
            </div>
            <div className="info-box">
              <div className="image">
                <Image alt="Icon2" name="jumbo-pay/Icon2" ext="png" />
              </div>
              <h3 className="title">
                {getTextByKey("aboutjumbopay-box2-title")}
              </h3>
              <p className="content">
                {getTextByKey("aboutjumbopay-box2-text")}
              </p>
            </div>
            <div className="info-box">
              <div className="image">
                <Image alt="Icon3" name="jumbo-pay/Icon3" ext="png" />
              </div>
              <h3 className="title">
                {getTextByKey("aboutjumbopay-box3-title")}
              </h3>
              <p className="content">
                {getTextByKey("aboutjumbopay-box3-text")}
              </p>
            </div>
          </div>

          <div className="scroller" onClick={() => executeScroll()}>
            <svg
              width="60"
              height="26"
              viewBox="0 0 60 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="arrow-down"
            >
              <path
                opacity="0.2"
                d="M4 4L30 21L56 4"
                stroke="#9CA9AF"
                strokeWidth="8"
                strokeLinecap="round"
              ></path>
            </svg>
            <svg
              width="6"
              height="38"
              viewBox="0 0 6 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="dots"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 3C6 4.65686 4.65686 6 3 6C1.34314 6 0 4.65686 0 3C0 1.34314 1.34314 0 3 0C4.65686 0 6 1.34314 6 3ZM6 19C6 20.6569 4.65686 22 3 22C1.34314 22 0 20.6569 0 19C0 17.3431 1.34314 16 3 16C4.65686 16 6 17.3431 6 19ZM3 38C4.65686 38 6 36.6569 6 35C6 33.3431 4.65686 32 3 32C1.34314 32 0 33.3431 0 35C0 36.6569 1.34314 38 3 38Z"
                fill="#EBEEEF"
              ></path>
            </svg>
          </div>
        </div>
      </div>
      <div ref={myRef} className="section-2">
        <div className="use-jumbopay-texts">
          <div className="texts">
            <h2 className="title">
              {getTextByKey("aboutjumbopay-first-section-title")}
            </h2>
            <p className="content">
              {getTextByKey("aboutjumbopay-first-section-text")}
            </p>
          </div>
          <div className="image">
            <Image
              className="folderImage"
              alt="folder"
              name="jumbo-pay/folder"
              ext="png"
            />
          </div>
        </div>
      </div>
      <div className="section-3">
        <div className="use-jumbopay-texts">
          <div className="image">
            <Image alt="waterMark" name="jumbo-pay/waterMark" ext="png" />
          </div>
          <div className="texts">
            <h2 className="title">
              {getTextByKey("aboutjumbopay-second-section-title")}
            </h2>
            <p className="content"></p>
            {getHtmlByKey("aboutjumbopay-second-section-text")}

            <Button buttonClass="jm-button">
              <LinkToNewTab page="home">
                {getTextByKey("aboutjumbopay-request-payment").toUpperCase()}
              </LinkToNewTab>
            </Button>

            <p></p>
          </div>
        </div>
      </div>
      <div className="section-4">
        <div className="try-jumbomail">
          <div className="logo">
            <svg
              width="68"
              height="68"
              viewBox="0 0 68 68"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="34" cy="34" r="34" fill="#C1E8EF"></circle>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.6667 19H21C19.3431 19 18 20.3431 18 22V46.1282C18 47.7851 19.3431 49.1282 21 49.1282H45.1282C46.7851 49.1282 48.1282 47.7851 48.1282 46.1282V35.8718H45.1282V46.1282H21V22V22H33.6667V19Z"
                fill="#15B4D4"
              ></path>
              <path
                d="M43.4033 22.2594C43.0448 21.881 42.4412 21.8592 42.0552 22.2107L32.7424 34.3853L29.3263 30.4179C28.9538 30.0527 28.3498 30.0527 27.9773 30.4179L25.2794 33.0628C24.9069 33.428 24.9069 34.0201 25.2794 34.3853L31.6244 40.9044C31.6981 40.9767 31.7808 41.0346 31.869 41.0783L32.7424 42C33.1009 42.3784 33.7045 42.4002 34.0904 42.0487L45.9503 26.3215C46.3363 25.97 46.3585 25.3783 46 25L43.4033 22.2594Z"
                fill="#15B4D4"
              ></path>
              <path
                d="M57.881 54.6217L45.6939 42.1217C45.5777 42.0025 45.403 41.9675 45.2511 42.0317C45.0991 42.0959 45 42.2484 45 42.4167V60.75C45 60.9258 45.108 61.0833 45.2698 61.1425C45.4306 61.2025 45.6118 61.15 45.7207 61.0141L48.9657 56.9467L51.1309 61.7583C51.1992 61.91 51.3462 62 51.4998 62C51.5534 62 51.6078 61.9892 51.6599 61.9658L54.5035 60.7158C54.6043 60.6716 54.6839 60.5875 54.7229 60.4825C54.7619 60.3775 54.7587 60.2608 54.7124 60.1583L52.5406 55.3333H57.5934C57.7575 55.3333 57.9062 55.2317 57.9688 55.0758C58.0321 54.92 57.9972 54.7417 57.881 54.6217Z"
                fill="black"
              ></path>
            </svg>
          </div>
          <div className="text">
            <p>{getHtmlByKey("aboutjumbopay-try-jumbomail")}</p>

            <Button buttonClass="expirience-btn">
              <LinkToNewTab page="home">
                {getTextByKey("aboutjumbopay-try-it-now").toUpperCase()}
              </LinkToNewTab>
            </Button>
          </div>
        </div>
      </div>
      <div className="section-5">
        <div className="texts">
          <h2 className="title">
            {getTextByKey("aboutjumbopay-use-cases-title")}
          </h2>
          <p className="content">
            {getTextByKey("aboutjumbopay-use-cases-text")}
          </p>
        </div>
        <div className="bubbles">
          <div className="bubbles-row">
            {mapArray1.map((item) => {
              return (
                <div className={`bubble ${item.className}`}>
                  <Image
                    alt={item.image}
                    name={`jumbo-pay/${item.image}`}
                    ext="png"
                  />
                  <span className="bubble-title">
                    {getTextByKey(item.textKey)}
                  </span>
                </div>
              );
            })}
          </div>
          <div className="bubbles-row">
            {mapArray2.map((item) => {
              return (
                <div className={`bubble ${item.className}`}>
                  <Image
                    alt={item.image}
                    name={`jumbo-pay/${item.image}`}
                    ext="png"
                  />
                  <span className="bubble-title">
                    {getTextByKey(item.textKey)}
                  </span>
                </div>
              );
            })}
          </div>
          <div className="bubbles-row">
            {mapArray3.map((item) => {
              return (
                <div className={`bubble ${item.className}`}>
                  <Image
                    alt={item.image}
                    name={`jumbo-pay/${item.image}`}
                    ext="png"
                  />
                  <span className="bubble-title">
                    {getTextByKey(item.textKey)}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="section-6">
        <div className="use-jumbopay-texts">
          <div className="texts">
            <h2 className="title">
              {getTextByKey("aboutjumbopay-third-section-title")}
            </h2>
            <p className="content">
              {getTextByKey("aboutjumbopay-third-section-text")}
            </p>

            <Button buttonClass="jm-button">
              <LinkToNewTab page="home">
                {getTextByKey("aboutjumbopay-request-payment").toUpperCase()}
              </LinkToNewTab>
            </Button>
          </div>
          <div className="image">
            <Image
              className="folder-image2"
              alt="Folder2"
              name="jumbo-pay/Folder2"
              ext="png"
            />
          </div>
        </div>

        <div className="clouds">
          <div className="cloud-left"></div>
          <div className="cloud-right"></div>
        </div>
      </div>
      <div className="section-7" id="pricing-table">
        <div className="intro">
          <h2>{getTextByKey("aboutjumbopay-four-section-title")}</h2>
          <p>{getTextByKey("aboutjumbopay-four-section-text")}</p>
        </div>
        <div className="level-table">
          <p className="table-explenation">
            {getTextByKey("aboutjumbopay-subs-get-best")}
          </p>
          <div className="levels">
            <div className="level pink">
              <div
                className={`level-name ${
                  getDirection() === "rtl" ? "" : "level-name-ltr"
                }`}
              >
                <span> {getTextByKey("aboutjumbopay-for-pro-subs")}</span>
              </div>
              <div className="level-explenation">
                {" "}
                {getTextByKey("aboutjumbopay-for-pro-price")}
              </div>
              <div
                className={`level-percentage ${
                  getDirection() === "rtl" ? "" : "level-percentage-ltr"
                }`}
              >
                3.2%
              </div>
            </div>
            <div className="level pink">
              <div
                className={`level-name ${
                  getDirection() === "rtl" ? "" : "level-name-ltr"
                }`}
              >
                <span>{getTextByKey("aboutjumbopay-for-business-subs")}</span>
              </div>
              <div className="level-explenation">
                {getTextByKey("aboutjumbopay-for-pro-price")}
              </div>
              <div
                className={`level-percentage ${
                  getDirection() === "rtl" ? "level-percentage-ltr" : ""
                }`}
              >
                2.9%
              </div>
            </div>
          </div>
        </div>
        <LevelTable />

        <WithdrawTable />
      </div>
    </div>
  );
};

export default JumboPay;
